import type { FlipperState } from './Flipper.types';
import type { FlipperAction } from './actions';
import { FLIPPER_ON, FLIPPER_OFF, FLIPPER_HYDRATE } from './actions';
import { INIT_STATE } from './Flipper.constants';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import { APP_CHANGE_ACTION_TYPE, INIT_WRAPPER_STATE } from '../../constants/ReduxAsyncActions.constants';

function hydrate(state: WrappedReducer<FlipperState>): WrappedReducer<FlipperState> {
  if (!state) {
    return { ...INIT_WRAPPER_STATE, ...INIT_STATE };
  }

  if (typeof window === 'undefined') {
    console.debug('Window object not found');
    return state;
  }

  const features = (window.App && window.App.context && window.App.context.flipper) || {};
  console.debug('Hydrate: ', features);
  return { ...state, features: { ...features } };
}

function handler(state: WrappedReducer<FlipperState>, action: FlipperAction): WrappedReducer<FlipperState> {
  switch (action.type) {
    case FLIPPER_ON.response:
      return { ...state, loading: false, error: false, featuresSaved: { ...state.featuresSaved, [action.data]: 'on' } };

    case FLIPPER_OFF.response:
      return { ...state, loading: false, error: false, featuresSaved: { ...state.featuresSaved, [action.data]: 'off' } };

    case FLIPPER_HYDRATE:
      return hydrate(state);

    default:
      return state;
  }
}

const FlipperUpdates = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [FLIPPER_ON, FLIPPER_OFF],
  error: [FLIPPER_ON, FLIPPER_OFF],
  resetOn: [APP_CHANGE_ACTION_TYPE],
});

export default FlipperUpdates;
